import React from 'react';
import Cookies from 'js-cookie';

class FooterNote extends React.Component{
    render() {
        return(
            <>
            {Cookies.get('geolocation') === "US" &&
                <div className="container citizen-footer-note text-center">
                    <div className="attribution" dangerouslySetInnerHTML={{__html: global.footerNote}}></div>
                </div>
            }
            </>
        )
    }
}
export default FooterNote